import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { setDefaultNamesLanguage } from '../utils/defaultNames';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange: MenuProps['onClick'] = ({ key }) => {
    i18n.changeLanguage(key);
    setDefaultNamesLanguage(key);
  };

  const isEs = i18n.language.startsWith('es');
  const isFr = i18n.language.startsWith('fr');
  const isZh = i18n.language.startsWith('zh');

  const getCurrentLang = () => {
    if (isZh) return 'ZH';
    if (isEs) return 'ES';
    if (isFr) return 'FR';
    return 'EN';
  };

  const items: MenuProps['items'] = [
    {
      key: 'en-US',
      label: 'EN',
    },
    {
      key: 'es-ES',
      label: 'ES',
    },
    {
      key: 'fr-FR',
      label: 'FR',
    },
  ];

  return (
    <Dropdown menu={{ items, onClick: handleChange }} trigger={['click']} placement="bottomRight">
      <span className="lang-switcher-trigger">
        <GlobalOutlined className="lang-icon" />
        <span className={`lang-badge ${isZh ? 'lang-badge--zh' : 'lang-badge--en'}`}>
          {getCurrentLang()}
        </span>
      </span>
    </Dropdown>
  );
};

export default LanguageSwitcher;
